import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Problem } from "@/components/site/Problem";
import { Pillars } from "@/components/site/Pillars";
import { PolicyReview, PolicyReviewTeaser } from "@/components/site/PolicyReview";
import PolicyReviewPage from "@/components/site/PolicyReviewPage";
import ResourcesPage from "@/components/site/resources/ResourcesPage";
import ArticlePage from "@/components/site/resources/ArticlePage";
import { BookCall } from "@/components/site/BookCall";
import { StartLearning } from "@/components/site/StartLearning";
import { Footer } from "@/components/site/Footer";
import AdminPage from "@/components/admin/AdminPage";
import FreeGuidePage from "@/components/site/FreeGuidePage";
import ThankYouPage from "@/components/site/ThankYouPage";
import QuizPage from "@/components/site/quiz/QuizPage";
import QuizThankYouPage from "@/components/site/QuizThankYouPage";
import HowItWorksPage from "@/components/site/HowItWorksPage";
import FaqPage from "@/components/site/FaqPage";
import AboutPage from "@/components/site/AboutPage";

const sonnerOpts = {
  position: "bottom-right",
  toastOptions: {
    style: {
      background: "#1C1A17",
      color: "#F5F0E8",
      border: "1px solid #B89A6E",
      fontFamily: "Inter, sans-serif",
      fontSize: "13px",
      letterSpacing: "0.02em",
    },
  },
};

export default function App() {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";

  // Bypass React and serve the raw static Strategy Profile HTML
  if (path === "/strategy-profile" || path === "/strategy-profile/") {
    if (typeof window !== "undefined") {
      window.location.replace("/strategy-profile.html");
    }
    return null;
  }

  if (path.startsWith("/admin")) {
    return (
      <>
        <AdminPage />
        <Toaster {...sonnerOpts} />
      </>
    );
  }

  if (path.startsWith("/free-guide/thank-you")) {
    return (
      <>
        <ThankYouPage />
        <Toaster {...sonnerOpts} />
      </>
    );
  }

  if (path.startsWith("/free-guide")) {
    return (
      <>
        <FreeGuidePage />
        <Toaster {...sonnerOpts} />
      </>
    );
  }

  if (path.startsWith("/quiz/thankyou") || path.startsWith("/quiz/thank-you")) {
    return (
      <>
        <QuizThankYouPage />
        <Toaster {...sonnerOpts} />
      </>
    );
  }

  if (path.startsWith("/quiz")) {
    return (
      <>
        <QuizPage />
        <Toaster {...sonnerOpts} />
      </>
    );
  }

  if (path.startsWith("/how-it-works")) {
    return (
      <>
        <HowItWorksPage />
        <Toaster {...sonnerOpts} />
      </>
    );
  }

  if (path.startsWith("/faq")) {
    return (
      <>
        <FaqPage />
        <Toaster {...sonnerOpts} />
      </>
    );
  }

  if (path === "/about" || path === "/about/") {
    return (
      <>
        <AboutPage />
        <Toaster {...sonnerOpts} />
      </>
    );
  }

  if (path.startsWith("/policy-review")) {
    return (
      <>
        <PolicyReviewPage />
        <Toaster {...sonnerOpts} />
      </>
    );
  }

  if (path === "/resources" || path === "/resources/") {
    return (
      <>
        <ResourcesPage />
        <Toaster {...sonnerOpts} />
      </>
    );
  }

  if (path.startsWith("/resources/")) {
    const slug = path.replace(/^\/resources\//, "").replace(/\/$/, "");
    return (
      <>
        <ArticlePage slug={slug} />
        <Toaster {...sonnerOpts} />
      </>
    );
  }

  return (
    <div className="App font-sans bg-paper text-nearblack antialiased">
      <Nav />
      <main>
        <Hero />
        <Problem />
        <Pillars />
        <PolicyReviewTeaser />
        <BookCall />
        <StartLearning />
      </main>
      <Footer />
      <Toaster {...sonnerOpts} />
    </div>
  );
}
